import 'malihu-custom-scrollbar-plugin';

var $targetNodes = $('.js-custom-scroll');
var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
var myObserver = new MutationObserver(mutationHandler);
var obsConfig = { childList: true, characterData: true, attributes: true, subtree: true };

$targetNodes.each(function () {
  myObserver.observe(this, obsConfig);
});

function mutationHandler(mutationRecords) {
  mutationRecords.forEach(function (mutation) {
    if (mutation.type == 'childList') {
      myObserver.disconnect();

      setTimeout(function () {
        $targetNodes.mCustomScrollbar({
          axis: 'x',
          advanced: {
            autoExpandHorizontalScroll: false,
          },
        });
      }, 1000);
    }
  });
}
